import React from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import classes from '../styles.module.scss';
import { ArrowRightLongIcon, MenuCloseIcon } from '../../../../assets/icons';
interface IProps {
    setIsOpen: (isOpen: boolean) => void;
    menuType?: 'default' | 'settings';
}

const MenuHeader: React.FC<IProps> = ({ setIsOpen, menuType = 'default' }) => {
    const { t } = useTranslation();
    const { kato, link, tab, type } = useParams<{kato: string, link: string, tab: string, type: string }>();
    const navigate = useNavigate();

    return (
        <div className={classes['menu-header']}>
            <div className={classes['menu-header__path']}>
                {menuType === 'settings'
                    ? <span className={classes['menu-header__link']}>{t('menu.settings')}</span>
                    : <span className={classes['menu-header__link']}>{t('menu.' + link)}</span>}

                {tab && <>
                    <ArrowRightLongIcon />
                    <span>{t(`menu.${tab}`)}</span>
                </>}
                {type && <>
                    <ArrowRightLongIcon />
                    <span>{t(`menu.${type}`)}</span>
                </>}
            </div>

            <div className={classes['menu-header__close']} onClick={() => {
                setIsOpen(false)
                navigate(`/${kato}`);
            }}>{<MenuCloseIcon />}</div>
        </div>
    )
}

export default MenuHeader